import * as React from 'react';
import { createRoot } from 'react-dom/client';

import './main.scss';
import App from './pages/app/app';

export const create = ({ root, config }) => {
  const appRoot = createRoot(root);

  appRoot.render(<App config={config} />);
};
